export default "__VITE_ASSET__DiyB4szf__"